import script from "./ContinuePathwayCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContinuePathwayCard.vue?vue&type=script&setup=true&lang=ts"

import "./ContinuePathwayCard.vue?vue&type=style&index=0&id=056d229e&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1140266145/src/hackingclub-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-056d229e"]])

export default __exports__